import { addCommas } from '@/utils';

export const ExperienceProgressBar = ({
	currentValue,
	totalValue
}: {
	currentValue: number;
	totalValue: number;
}) => {
	const minValue = Math.min(currentValue, totalValue);
	const percentage = ((minValue / totalValue) * 100).toFixed(2)

	return (
		<div className="shop-coin-threshold__progress">
			<div className="shop-coin-threshold__progress-text">
				{addCommas(minValue)}/{addCommas(totalValue)}
			</div>
			<div 
				className="shop-coin-threshold__progress-bar" 
				style={{ width: `${percentage}%` }}
			>
			</div>
		</div>
	);
};